// Check if the app is running in standalone mode (installed as PWA)
export const isRunningStandalone = () => {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone ||
    document.referrer.includes('android-app://') ||
    window.location.search.includes('source=pwa')
  );
};

// Check if the browser supports PWA installation
export const isPWAInstallable = () => {
  // Check for beforeinstallprompt event support
  const isStandalone = isRunningStandalone();
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isHTTPS = window.location.protocol === 'https:' || window.location.hostname === 'localhost';
  
  return !isStandalone && isMobile && isHTTPS;
};

// Check if the app is installed
export const isAppInstalled = () => {
  return isRunningStandalone();
};

// Debug function to check PWA capabilities
export const checkPWASupport = () => {
  return {
    isStandalone: isRunningStandalone(),
    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    isHTTPS: window.location.protocol === 'https:' || window.location.hostname === 'localhost',
    beforeInstallPrompt: 'BeforeInstallPromptEvent' in window,
    displayMode: window.matchMedia('(display-mode: standalone)').matches ? 'standalone' : 'browser',
    userAgent: navigator.userAgent
  };
};
